import { pathToRegexp } from 'path-to-regexp'

/**
 * A base HTTP request/response interceptor
 *
 * An implementering class can extend this, and receive interception using:
 *  * method matching
 *  * URL pattern matching (using an express-like syntax)
 */
export class BaseInterceptor {
  constructor ({ method, path } = {}) {
    this.method = method
    this.path = path
    this.keys = []
    this.pattern = pathToRegexp(this.path, this.keys)
  }

  /**
   * Call to attempt interception of the request/response
   * If the interceptor is not a match, the method does not continue and no response is given
   *
   * @param {object} ctxt Request/Response context
   * @param {object} params Params to pass to the onIntercept event handler
   * @returns {object|undefined} The request config or response context if intercepted, otherwise undefined
   */
  use (ctxt, params = {}) {
    if (this.method !== ctxt.config.method) {
      return
    }

    const matches = this.pattern.exec(ctxt.config.url)
    if (!matches) {
      return
    }

    const [ , ...groups ] = matches

    this.keys.forEach(({ name }, idx) => {
      params[name] = groups[idx]
    })

    return this.onIntercept(ctxt, params)
  }

  /**
   * Classes that extend this base interceptor should implement this method
   * Upon interception, this method will be called with the request/response context and any available params
   * given to this interceptor or found this in the URL pattern
   *
   * @param {object} ctxt Request/Response context
   * @param {object} params Contextual params
   * @returns {object} Request config or Response context
   */
  async onIntercept (ctxt, params = {}) {
    throw new Error(`onIntercept not implemented in ${this.constructor.name}`)
  }
}
